import React from 'react';
import './TrackAnything.scss';

interface Vehicle {
  image: string;
  name: string;
}

const TrackAnything: React.FC = () => {
  const vehicles: Vehicle[] = [
    { image: '/Cars.png', name: 'Cars' },
    { image: '/Motorcycles.png', name: 'Motorcycles' },
    { image: '/Bicycles.png', name: 'Bicycles' },
    { image: '/Electric Scooters.png', name: 'Electric Scooters' },
    { image: '/RVs.png', name: 'RVs' },
    { image: '/Yachts.png', name: 'Yachts' }
  ];

  return (
    <section id="track-anything" className="track-anything">
      <div className="container">
        <h2>Track Anything That Matters</h2>
        <p>Protect your valuable assets with invisible GPS tracking</p>
        
        <div className="vehicles-grid">
          {vehicles.map((vehicle, index) => (
            <div key={index} className="vehicle-card">
              <img src={vehicle.image} alt={vehicle.name} />
              <h3>{vehicle.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrackAnything;
